import { Box, Grid, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const GettingStarted = () => {
  const { t } = useTranslation(['integrations']);
  return (
    <Grid
      templateColumns={{ md: '1fr', lg: 'repeat(2, 1fr)' }}
      gap={6}
      boxShadow="0 0 5px 0 #e1e1e1"
      borderRadius="5px"
      padding="10px 20px 20px 20px"
    >
      <Box minWidth="300px">
        <Text fontSize="md" mb={4}>
          {t('integrations:quickbooksDesktop.systemRequirements')}
        </Text>
        <UnorderedList>
          <ListItem>{t('integrations:quickbooksDesktop.systemList.enterprise')}</ListItem>
          <ListItem>{t('integrations:quickbooksDesktop.systemList.premier')}</ListItem>
          <ListItem>{t('integrations:quickbooksDesktop.systemList.pro')}</ListItem>
          <ListItem>{t('integrations:quickbooksDesktop.systemList.simpleStart')}</ListItem>
        </UnorderedList>
        <Text fontSize="md" mt={4} mb={4}>
          {t('integrations:quickbooksDesktop.intlSupportedEditions')}
        </Text>
        <UnorderedList>
          <ListItem>{t('integrations:quickbooksDesktop.intlSupportedSystems.canadian')}</ListItem>
          <ListItem>{t('integrations:quickbooksDesktop.intlSupportedSystems.uk')}</ListItem>
        </UnorderedList>
      </Box>
      {/* <Box minWidth="200px">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/Gmvan0zKzOQ"
          title="getting started"
        ></iframe>
      </Box> */}
    </Grid>
  );
};
export default GettingStarted;
